import _ from 'lodash';
import colorHelper from '$$helpers/color';
import constants from '$$helpers/constants';
import { getBlockedItemsByRights } from './helpers';
import getSvgIcon from '../../helpers/getSvgIcon';

class MassChangeContextMenu {
  #instance;

  #selectedItemsCount;

  #isTemplateLoaded = false;

  #contextMenuList;

  #contextMenuPopup;

  #contextMenuItemsConfig = [
    {
      id: 'app_masschange_menu_choose_color',
      css: 'context_menu_list_border_bottom context_menu_list_right_arrow',
      icon: getSvgIcon('color-backgroud', 'bold', 24),
      mouseMoveHandler: node => this.#showColorBoard(node),
    },
    {
      id: 'app_masschange_menu_remove',
      css: 'context_menu_list_border_bottom',
      icon: getSvgIcon('delete', 'regular', 24),
      handler: () => {},
    }
  ];

  init(instance) {
    this.#instance = instance;

    if (!this.#isTemplateLoaded) {
      loadWebixTemplates();
      this.#isTemplateLoaded = true;
    }

    this.#contextMenuList = $$(innerViews.contextMenuList.id);
    this.#contextMenuPopup = $$(innerViews.main.id);
    this.#attachColorBoardEvents();
  }

  onContextMenu(taskId, linkId, event) {
    const canShowContextMenu = [
      this.#instance.ganttDataApi.isMassChangeEnabled(),
    ];

    if (canShowContextMenu.every(Boolean)) {
      const config = {
        anchorPosition: this.#getClickPosition(event),
      };
  
      this.show(config);
    } else {
      this.hide();
    }
  }

  #getClickPosition(event) {
    return {
      x: event.clientX + document.body.scrollLeft + document.documentElement.scrollLeft,
      y: event.clientY + document.body.scrollTop + document.documentElement.scrollTop,
    };
  }

  show(config) {
    this.#selectedItemsCount = this.#instance.ganttDataApi.getMassChangeSelectedItems().length;

    const { anchorPosition } = config;
    const menuItems = this.#prepareMenuItems();

    if (!menuItems.length) {
      return;
    }

    this.#contextMenuPopup.show(anchorPosition);
  }

  hide() {
    if ($$(innerViews.taskColorPopup.id).isVisible()) {
      $$(innerViews.taskColorPopup.id).hide();
    }

    if (this.#contextMenuPopup.isVisible()) {
      this.#selectedItemsCount = null;
      this.#contextMenuPopup.hide();
    }
  }

  #showColorBoard(node, position) {
    if (!position || _.isEmpty(position)) {
      position = {
        pos: 'right',
        x: 0,
        y: -1,
      };
    }

    $$(innerViews.taskColorPopup.id).show(node, position);
  }

  #prepareMenuItems() {
    this.#contextMenuList.clearAll();
    this.#contextMenuList.parse(this.#composeMenuItemsData(this.#contextMenuItemsConfig));

    this.#showAllMenuItems();
    this.#filterMenuItemsByRights();

    return this.#contextMenuList.serialize();
  }

  #composeMenuItemsData(config) {
    return config.map(configItem => ({
      id: configItem.id,
      icon: configItem.icon,
      disabled: !this.#selectedItemsCount,
      $css: `${configItem.css} ${!this.#selectedItemsCount ? 'menu-list-disabled' : ''}`,
      handler: this.#menuItemClickHandler.bind(this),
      mouseMoveHandler: configItem.mouseMoveHandler,
      value: __(configItem.id),
      $template: configItem.$template,
    }));
  }

  #showAllMenuItems() {
    this.#contextMenuItemsConfig.forEach(item => this.#contextMenuList.showItem(item.id));
  }

  #filterMenuItemsByRights() {
    const activeGanttId = this.#instance.ganttDataApi.getActiveProjectId();
    const blockItems = getBlockedItemsByRights(activeGanttId);

    if (blockItems.length) {
      const menuItems = this.#contextMenuList.serialize();

      menuItems.forEach(item => {
        if (blockItems.includes(item.id)) {
          this.#contextMenuList.hideItem(item.id);
        }
      });
    }
  }

  #menuItemClickHandler(item, event, node) {
    switch (item.id) {
    case 'app_masschange_menu_remove':
      // app.trigger('gantt:keyboard:disable');
      
      webix.confirm({
        ok: __('common_yes'),
        cancel: __('common_cancel'),
        text: __('app_masschange_confirm_rm_text'),
        type: 'confirm-error',
        width: 420,
      }).then(result => {
        if (result) {
          const activeGanttId = this.#instance.ganttDataApi.getActiveProjectId();
          const tasksToDelete = this.#instance.ganttDataApi.getMassChangeSelectedItems().map(id => ({ id, gantt_id: +activeGanttId }));

          this.#instance.callEvent('setMassSelectEnabled', [false]);
          this.#instance.callEvent('onMassDeleteTasks', [tasksToDelete]);
        }
        // app.trigger('gantt:keyboard:enable');
      });

      break;
    case 'app_masschange_menu_choose_color':
      return;
    }

    this.hide();
  }

  #attachColorBoardEvents() {
    $$(innerViews.taskColorBoard.id).attachEvent('onSelect', colorHex => {
      $$(innerViews.taskColorBoard.id).setValue();
      $$(innerViews.taskColorBoard.id).refresh();

      const activeGanttId = this.#instance.ganttDataApi.getActiveProjectId();
      const color = colorHelper.getColorId(colorHex);
      const tasksToUpdate = this.#instance.ganttDataApi.getMassChangeSelectedItems().map(id => ({ id, gantt_id: +activeGanttId, color }));

      this.hide();

      this.#instance.callEvent('setMassSelectEnabled', [false]);
      this.#instance.callEvent('onMassUpdateTasks', [tasksToUpdate]);
    });
  }
}

const innerTemplates = {
  menuItem: item => {
    return `<div class='context_menu_list_item_icon'>${item.icon}</div>`
      + `<div class='context_menu_list_item_text'>${item.value}</div>`;
  },
};

const innerViews = {
  taskColorPopup: {
    id: 'mcGridColorboardPopup',
  },
  main: {
    id: 'mcContextMenu',
  },
  contextMenuList: {
    id: 'mcContextMenuList',
    view: 'menu',
    css: 'context_menu_list',
    borderless: true,
    autoheight: true,
    layout: 'y',
    template: innerTemplates.menuItem,
    data: [],
    type: {
      height: 32,
    },
    on: {
      onItemClick(id, event, node) {
        const item = this.getItem(id);

        item.handler && item.handler(item, event, node);

        item.mouseMoveHandler && item.mouseMoveHandler(node);
      },
      onMouseMove(id, e, node) {
        const item = this.getItem(id);

        if (!_.includes(['app_masschange_menu_choose_color'], id)) {
          $$(innerViews.taskColorPopup.id).hide();
        }

        item.mouseMoveHandler && item.mouseMoveHandler(node);
      },
    },
  },
  taskColorBoard: {
    id: 'mcGridColorboard',
    view: 'colorboardCst',
    css: 'task-settings-color-board',
    width: 180,
    height: 120,
    palette: constants.PALETTE_CONFIG.palette.map(item => item.map(cell => cell.color)),
    template(obj) {
      return `<div class="color-bar" style="background: ${obj.val};"><div class="color-bar-inside-border"></div></div>`;
    },
  },
};

function loadWebixTemplates() {
  // exclude webix templates from public url app

  webix.ui({
    id: innerViews.taskColorPopup.id,
    view: 'popupWithoutPoint',
    css: 'grid-colorboard-popup',
    padding: 8,
    hidden: true,
    body: innerViews.taskColorBoard,
  });

  webix.ui({
    id: innerViews.main.id,
    view: 'popupWithoutPoint',
    css: 'context_menu_popup',
    hidden: true,
    borderless: true,
    autoheight: true,
    width: 237,
    body: {
      rows: [
        innerViews.contextMenuList,
      ],
    },
    on: {
      onHide() {
        $$(innerViews.contextMenuList.id).clearAll();
      },
    },
  });
}

export default new MassChangeContextMenu();
